module.exports = __webpack_public_path__ + "static/media/crehana-white.30ea017b.svg";